import Vue from "vue";
import App from "./App.vue";
import { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.config.productionTip = false;
// Vue.use(Message);
Vue.prototype.$message = Message;
new Vue({
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
